import { IStateUser } from 'src/entity/StateEntity';
import { USER_TYPE_AGENT, USER_TYPE_DRUG_STORE } from 'src/constants/ActionTypes';
import { DATA_CLEAR } from '../../constants/ActionTypes';

const initialState: IStateUser = {
  isAgent: true,
  isDomestic: true,
  type: USER_TYPE_AGENT,
  userInfo: undefined,
};

export const userState = (state: IStateUser = initialState, action: IStateUser): IStateUser => {
  switch (action.type) {
    case USER_TYPE_AGENT:
      return Object.assign({}, state, {
        type: action.type,
        isAgent: true,
        isDomestic: action.isDomestic,
        userInfo: action.userInfo,
      });
    case USER_TYPE_DRUG_STORE:
      return Object.assign({}, state, {
        type: action.type,
        isAgent: false,
        isDomestic: action.isDomestic,
        userInfo: action.userInfo,
      });
    case DATA_CLEAR:
      return Object.assign({}, state, {
        type: action.type,
        isAgent: false,
        isDomestic: action.isDomestic,
        userInfo: undefined,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/userState.ts